import React from 'react';
import { IconProps } from '../../Icons';

interface ToolButtonProps {
  name: string;
  icon: React.ComponentType<IconProps>;
  shortcut: string;
  isActive: boolean;
  onClick: () => void;
}

export const ToolButton: React.FC<ToolButtonProps> = ({
  name,
  icon: IconComponent,
  shortcut,
  isActive,
  onClick,
}) => {
  return (
    <button
      className={`
        relative group w-12 h-12 rounded-lg border-2 transition-all duration-200
        hover:scale-105 hover:shadow-md
        ${isActive 
          ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-md' 
          : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
        }
      `}
      onClick={onClick}
      title={`${name} (${shortcut})`}
    >
      {/* Icon */}
      <div className="flex items-center justify-center w-full h-full">
        <IconComponent 
          className="w-6 h-6" 
          size={24}
        />
      </div>
      
      {/* Active indicator */}
      {isActive && (
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full border-2 border-white" />
      )}
      
      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
        {name}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800" />
      </div>
    </button>
  );
};
